import { Route, Routes } from 'react-router-dom';

import Layout from './components/layout/Layout';
import ScrollToTop from './components/layout/ScrollToTop';
import SeoManager from './components/layout/SeoManager';
import Analytics from './components/layout/Analytics';
import { ToastProvider } from './components/ui/Toast';

import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Industries from './pages/Industries';
import Process from './pages/Process';
import Compliance from './pages/Compliance';
import Contact from './pages/Contact';
import RequestPickup from './pages/RequestPickup';
import NotFound from './pages/NotFound';

export default function App() {
  return (
    <ToastProvider>
      <ScrollToTop />
      <SeoManager />
      <Analytics />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/process" element={<Process />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/request-pickup" element={<RequestPickup />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </ToastProvider>
  );
}
